<template>
<div class="container-fluid">
    <div class="card animated fadeIn" v-if="!loading">
        <div class="card-body">
            <div>
                <b-tabs card justified lazy>
                    <b-tab title="Connection">
                        <!-- <plotconnectsform :serial="device.serial" :deviceID="this.device.id"></plotconnectsform> -->
                        <system :device=device></system>
                    </b-tab>
                    <b-tab title="Network Inferfaces" active>
                        <statusinterface :device=device></statusinterface>
                    </b-tab>
                    <b-tab title="Wireless Inferfaces">
                        <statuswirelessinterface :device=device></statuswirelessinterface>
                    </b-tab>
                    <b-tab title="DHCP leases">
                        <statusDHCPHosts :device=device></statusDHCPHosts>
                    </b-tab>
                    <b-tab title="Wireless Hosts">
                        <statusWIFIHosts :device="device"></statusWIFIHosts>
                    </b-tab>
                </b-tabs>
            </div>
            </b-card-body>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment'

import PlotConnectsForm from '@/readynet/devices/graphs/PlotConnectsForm';
import System from '@/readynet/devices/status/System';
import StatusInterfaces from '@/readynet/devices/status/StatusInterfaces';
import StatusWirelessInterfaces from '@/readynet/devices/status/StatusWirelessInterfaces';
import StatusDHCPHosts from '@/readynet/devices/status/StatusDHCPHosts';
import StatusWIFIHosts from '@/readynet/devices/status/StatusWIFIHosts';

export default {
    components: {
        'system': System,
        'plotconnectsform': PlotConnectsForm,
        'statusinterface': StatusInterfaces,
        'statuswirelessinterface': StatusWirelessInterfaces,
        'statusDHCPHosts': StatusDHCPHosts,
        'statusWIFIHosts': StatusWIFIHosts,

    },
    data() {
        return {
            loading: false,
            device: {
                type: Object,
                default: function () {
                    return {}
                }
            },
        }
    },
    props: {
        rowData: {
            type: Object,
            required: true
        },
        rowIndex: {
            type: Number
        }
    },
    methods: {
        onClick(event) {
            // console.log('my-detail-row: on-click', event.target)
        }
    },
    created() {
        this.loading = true;
        let uri = `/api/devices/${this.rowData.id}?meta=1`;
        axios.get(uri).then((response) => {
            this.device = response.data.data.device;

            this.loading = false;
        });
    },

}
</script>
